import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
  Button,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Slider,
  Chip,
} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import HeaderAppBar from '../components/HeaderAppBar';
import validations from './helpers/validations';
import { useTranslation } from 'react-i18next';
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function Config({ 
                  auth, 
                  user, 
                  userSettings, 
                  saveUserSettings, 
                  setAllowInteractivity,
                  allowInteractivity,
                  setShowControlsPlayer,
                  showControlsPlayer,
                  setVideoId,
                  videoId
                }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  

  const [apiKeys, setApiKeys] = useState(userSettings.configs.apiKeys);
  const [intros, setIntros] = useState(userSettings.configs.intros);
  const [transitions, setTransitions] = useState(userSettings.configs.transitions);
  const [monitorSyncOffsetSec, setMonitorSyncOffsetSec] = useState(
    userSettings?.monitorSyncOffsetSec ?? userSettings?.configs?.general?.monitorSyncOffsetSec ?? 0
  );
  const [isMonitorEnabled, setIsMonitorEnabled] = useState(
    (userSettings?.isMonitorEnabled ?? userSettings?.configs?.general?.isMonitorEnabled) !== false
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  const handleApiKeyChange = (index, value) => {
    const newApiKeys = [...apiKeys];
    newApiKeys[index] = value;
    setApiKeys(newApiKeys);
  };

  const handleIntroChange = (index, value) => {
    const newIntros = [...intros];
    newIntros[index] = value;
    setIntros(newIntros);
  };

  const handleTransitionChange = (index, value) => {
    const newTransitions = [...transitions];
    newTransitions[index] = value;
    setTransitions(newTransitions);
  };

  const cancel = () => {
    navigate('/');
  };

  const buttonStyles = {
    marginRight: '10px',
  };

  const handleSaveUserSettings=(e)=>{
    e.preventDefault();
    auth.onAuthStateChanged(user=>{
      let newUserSettings = userSettings;
      switch(e.target.pannelIndex.value){
        case 'general':
          newUserSettings.isMonitorEnabled = isMonitorEnabled;
          newUserSettings.monitorSyncOffsetSec = Number(monitorSyncOffsetSec) || 0;
          newUserSettings.configs.general = {
            showControlsPlayer: e.target.showControlsPlayer.checked,
            allowInteractivity: e.target.allowInteractivity.checked,
            isMonitorEnabled: isMonitorEnabled,
            monitorSyncOffsetSec: Number(monitorSyncOffsetSec) || 0,
            theme: 'dark',
          };
          break;
        case 'apiKeys':
          newUserSettings.configs.apiKeys = apiKeys;
          break;
        case 'intros':
          newUserSettings.configs.intros = intros;
          break;
        case 'transitions':
          newUserSettings.configs.transitions = transitions;
          break;
        default:
      }
      saveUserSettings(user.uid, newUserSettings);
    })
  }

  const apiKeysErrors = validations.checkApiKeysErrors(apiKeys)
  const introsErrors = validations.checkIntrosErrors(intros)
  const transitionsErrors = validations.checkTransitionsErrors(transitions)

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#000000' }}>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <HeaderAppBar 
          user={user} 
          setVideoId={setVideoId}
          videoId={videoId}
        />
        <main style={{ flexGrow: 1, overflow: 'auto' }}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              <Card elevation={3} style={{ padding: '16px', margin: '10px', height: 'calc(100vh - 100px)' }}>
                <CardContent>
                  <Grid container direction="row" justifyContent="space-evenly">
                    <Grid item xs={12} md={12}>
                      <Typography variant="h6" component="div">
                        {t('config.title')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                    <form autoComplete='off' className='form-group'  onSubmit={handleSaveUserSettings}>
                      <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                            <Tab label={t('config.tabGeneral')} {...a11yProps(0)} style={{ textTransform: 'none' }} />
                            <Tab label={t('config.tabApiKeys')} {...a11yProps(1)} style={{ textTransform: 'none' }} />
                            <Tab label={t('config.tabIntros')} {...a11yProps(2)} style={{ textTransform: 'none' }} />
                            <Tab label={t('config.tabTransitions')} {...a11yProps(3)} style={{ textTransform: 'none' }} />
                          </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}><input type='hidden' id='pannelIndex' value='general' />
                          <div id="configPannel1" class="configpannel_container scroll">
                            <FormGroup>
                              <FormControlLabel control={<Checkbox inputProps={{ "aria-label": "controlled" }} checked={showControlsPlayer} onClick={()=>setShowControlsPlayer(!showControlsPlayer)} id='showControlsPlayer'/>} label={t('config.showControls')} />
                              <FormControlLabel control={<Checkbox inputProps={{ "aria-label": "controlled" }} checked={allowInteractivity} onClick={()=>setAllowInteractivity(!allowInteractivity)} id='allowInteractivity'/>} label={t('config.allowInteractivity')} />
                              <FormControlLabel control={<Checkbox checked={isMonitorEnabled} onChange={(e)=>setIsMonitorEnabled(e.target.checked)} id='isMonitorEnabled'/>} label="Habilitar Pantallas de Monitor para Invitados (/monitor)" />
                              <Box sx={{ mt: 2, p: 2, background: 'rgba(255, 255, 255, 0.05)', borderRadius: '12px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    Tolerancia / Desfasaje de Monitores (Segundos)
                                  </Typography>
                                  <Chip label={`${monitorSyncOffsetSec > 0 ? '+' : ''}${monitorSyncOffsetSec}s`} size="small" color="primary" />
                                </Box>
                                <Slider
                                  value={Number(monitorSyncOffsetSec) || 0}
                                  onChange={(_, val) => setMonitorSyncOffsetSec(val)}
                                  min={-10}
                                  max={10}
                                  step={0.5}
                                  sx={{ color: '#00d4ff' }}
                                />
                              </Box>
                            </FormGroup>
                          </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}><input type='hidden' id='pannelIndex' value='apiKeys' />
                          <div id="configPannel2" class="configpannel_container scroll">
                            {t('config.apiKeysNotice')}
                            <p>
                            <ol>
                              <li>Dirígete a <a rel="noreferrer" href='https://console.cloud.google.com/apis/credentials' target='_blank'>https://console.cloud.google.com/apis/credentials</a></li>
                              <li>Botón [Crear credenciales] luego selecciona [Clave de API].</li>
                              <li>Listo! copia la clave desde la ventana de notificación del sitio y pégala aquí abajo. No olvides presionar en [Guardar] de este panel más abajo.</li>
                            </ol>
                            </p>
                            {apiKeys.map((key, index) => (
                              <TextField
                                key={`apikey_${index}`}
                                label={t('config.apiKeySlot', { number: index + 1 })}
                                variant="outlined"
                                fullWidth
                                value={key}
                                onChange={(e) => handleApiKeyChange(index, e.target.value)}
                                style={{ marginBottom: '10px' }}
                                error={apiKeysErrors['apikey_'+index].error}
                                helperText={apiKeysErrors['apikey_'+index].errorMsg}
                              />
                            ))}
                          </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}><input type='hidden' id='pannelIndex' value='intros' />
                          <div id="configPannel3" class="configpannel_container scroll">
                            {t('config.introsNotice')}
                            <p/>
                            {intros.map((key, index) => (
                              <TextField
                                key={`intro_${index}`}
                                label={t('config.introSlot', { number: index + 1 })}
                                variant="outlined"
                                fullWidth
                                value={key}
                                onChange={(e) => handleIntroChange(index, e.target.value)}
                                style={{ marginBottom: '10px' }}
                                error={introsErrors['intro_'+index].error}
                                helperText={introsErrors['intro_'+index].errorMsg}
                              />
                            ))}
                          </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}><input type='hidden' id='pannelIndex' value='transitions' />
                        <div id="configPannel4" class="configpannel_container scroll">
                            {t('config.transitionsNotice')}
                            <p/>
                            {transitions.map((key, index) => (
                              <TextField
                                key={`transition_${index}`}
                                label={t('config.transitionSlot', { number: index + 1 })}
                                variant="outlined"
                                fullWidth
                                value={key}
                                onChange={(e) => handleTransitionChange(index, e.target.value)}
                                style={{ marginBottom: '10px' }}
                                error={transitionsErrors['transition_'+index].error}
                                helperText={transitionsErrors['transition_'+index].errorMsg}
                              />
                            ))}
                          </div>
                        </CustomTabPanel>
                      </Box>
                      <div>
                        <Button type="submit" variant="contained" style={buttonStyles}>
                          {t('common.save')}
                        </Button>
                        <Button variant="contained" onClick={cancel} style={buttonStyles}>
                          {t('config.backToPanel')}
                        </Button>
                      </div>
                      </form>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </main>
      </div>
    </ThemeProvider>
    </div>
  );
}

export default Config;
